import { checkPermissions } from '../helpers/utils';

interface AccessControlProps {
  userPermissions: string[] | null | undefined;
  allowedPermissions: string[];
  children: React.ReactNode;
  noAccess?: React.ReactNode;
}

const AccessControl = ({
  userPermissions,
  allowedPermissions,
  children,
  noAccess,
}: AccessControlProps) => {
  const permitted = checkPermissions(userPermissions, allowedPermissions);
  if (permitted) {
    return children;
  }
  return noAccess;
};

export default AccessControl;
